import {
  getShortlists as getShortlistsServer,
  createShortlist as createShortlistServer,
  updateShortlist as updateShortlistServer,
  deleteShortlist as deleteShortlistServer,
  getShortlistEntries as getShortlistEntriesServer,
} from '@/actions/shortlists';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import { parseFileNameFromContentDisposition } from '@/utils/downloadUtil';

export const getShortlists = async (organizationId: string) => {
  const userAccessToken = await getUserAccessToken();
  return getShortlistsServer(userAccessToken, organizationId);
};

export const getShortlistEntries = async (shortlistId: string, page = 0, size = 100) => {
  const userAccessToken = await getUserAccessToken();
  return getShortlistEntriesServer(userAccessToken, shortlistId, page, size);
};

export const createShortlist = async (name: string) => {
  const userAccessToken = await getUserAccessToken();
  return createShortlistServer(userAccessToken, name);
};

export const updateShortlist = async (shortlistId: string, standard?: boolean, name?: string, rank?: number) => {
  const userAccessToken = await getUserAccessToken();
  return updateShortlistServer(userAccessToken, shortlistId, standard, name, rank);
};

export const deleteShortlist = async (shortlistId: string) => {
  const userAccessToken = await getUserAccessToken();
  return deleteShortlistServer(userAccessToken, shortlistId);
};

export const exportShortlistEntries = async (shortlistId: any) => {
  const userAccessToken = await getUserAccessToken();
  const res = await fetch(`/api/export/shortlists?shortlistId=${shortlistId}`, {
    headers: {
      Authorization: `${userAccessToken}`,
    },
  });

  const contentDisposition = res.headers.get('Content-Disposition');
  const fileName = parseFileNameFromContentDisposition(contentDisposition);
  const blob = await res.blob();

  return { blob, fileName };
};
